import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    textContent: {
      color: theme.palette.text.subtitle,
    },
    datepicker: {
      '.MuiFormLabel-root': {
        fontSize: '14px !important',
      },
    },
  };
});

export default useStyles;
